import { type EmojiId, type VisualizerDataKeys } from '../common/structs';

import { admin } from './admin';
import { artifacts } from './artifacts';
import { auth } from './auth';
import { cart } from './cart';
import { codes } from './codes';
import { collection } from './collection';
import { competitions } from './competitions';
import { daas } from './daas';
import { emoji } from './emoji';
import { gems } from './gems';
import { globalSearch } from './globalSearch';
import { invites } from './invites';
import { liquidId } from './liquidId';
import { lootBoxes } from './lootBoxes';
import { nft } from './nft';
import { orders } from './order';
import { organizations } from './organizations';
import { pods } from './pods';
import { teams } from './teams';
import { transfers } from './transfers';
import { user } from './user';
import { w3auth } from './w3auth';
import { wishlists } from './wishlists';
import { yatPage } from './yatPage';

export const links = {
    admin: () => admin,
    artifacts,
    auth,
    cart,
    codes,
    collection,
    competitions,
    daas,
    editions: () => '/editions',
    emoji,
    freeYat: () => '/yats/free',
    gem: () => ({ all: () => '/gems' }),
    gems,
    globalSearch,
    invites,
    liquidId,
    lootBoxes,
    nft,
    organizations,
    orders,
    pods,
    proxy: () => `/proxy`,
    segemnt: () => ({ event: () => '/sgmntprxy/event' }),
    status: () => `/status`,
    teams,
    transfers,
    user,
    userV2: () => ({ collection: () => '/v2/users' }),
    userInterests: () => ({
        collection: () => `/user_interests`,
        single: (id: EmojiId) => `/user_interests/${id}`,
    }),
    visualiser: () => ({
        get: (eid: EmojiId, keys: VisualizerDataKeys[]) => `/emoji_id/${eid}/json/?keys=${keys.join(',')}`,
        set: (eid: EmojiId, key: VisualizerDataKeys) => `/emoji_id/${eid}/json/${key}`,
    }),
    ws: () => ({
        single: () => `/ws`,
        token: () => `/ws/token`,
        incognito: () => `/ws/incognito`,
    }),
    fantasy: {
        lineupItems: (slug?: string, code?: string) =>
            slug ? `/lineups/${slug}/items` : code ? `/lineups/items?invite_code=${code}` : '/lineups/items',
        summary: (slug: string) => `/lineups/${slug}/portfolio-summary`,
        referral: (code: string) => `/lineups/items?invite_code=${code}`,
    },
    wishlists,
    w3auth,
    yatPage,
};
